import Vue from 'vue'
import VueRouter from 'vue-router'
import ImageUploaderRoutes from '@/views/imageuploader/Routes.js'
import SignInRoutes from '@/views/signin/Routes.js'
import MobileImageUploader from '@/views/mobileimageuploader/Routes.js'
// import Home from '../views/Home.vue'

const routes = [
  ...SignInRoutes,
  ...ImageUploaderRoutes,
  ...MobileImageUploader
]

Vue.use(VueRouter)

// const routes = [
//   {
//     path: '/',
//     name: 'home',
//     component: Home
//   },
//   {
//     path: '/about',
//     name: 'about',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
//   }
// ]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
